import type { CostCenter, FixedCost } from "../types.ts";
import { FixedCostsRow } from "./FixedCostsRow.tsx";
import { useStickyHead } from "../useStickyHead.ts";

type Props = {
  fixedCosts: FixedCost[];
  costCenters: CostCenter[];
  onPatch: (id: string, patch: Partial<FixedCost>) => void;
  onDelete: (id: string) => void;
  onAddAfter: (afterId: string) => void;
};

export function FixedCostsTable({
  fixedCosts,
  costCenters,
  onPatch,
  onDelete,
  onAddAfter,
}: Props) {
  const { sentinelRef, stuck } = useStickyHead();
  return (
    <>
      <div ref={sentinelRef} className="thead-sentinel" />
      <table className={stuck ? "thead-stuck" : ""}>
        <thead>
          <tr>
            <th className="col-description">Beskrivning</th>
            <th className="col-category">Kategori</th>
            <th className="col-cost-center">Kostnadsställe</th>
            <th className="col-day num">Dag</th>
            <th className="col-occurrence">Frekvens</th>
            <th className="col-amount num">Belopp</th>
            <th className="col-delete"></th>
          </tr>
        </thead>
        <tbody>
          {fixedCosts.map((cost) => (
            <FixedCostsRow
              key={cost.id}
              cost={cost}
              costCenters={costCenters}
              onPatch={onPatch}
              onDelete={onDelete}
              onAddAfter={onAddAfter}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}
